module.exports = __webpack_public_path__ + "distribution/img/ico_close.812cba78.svg";